// A JANELA DE 24 H DO WHATSAPP OFICIAL — a conta, sem tela (24/09/2026).
//
// Regra da Meta (documentação oficial, conferida): a janela ABRE ou RENOVA
// quando o cliente manda mensagem ou liga, e dura 24 h a partir da última.
// Fechada, só modelo aprovado — mensagem livre volta com o erro 131047. Mensagem
// do escritório NÃO reabre. O app WhatsApp Business do celular não segue a janela.
//
// Duas fontes, vale a mais nova: a hora que o servidor mandou (`janela_fecha_em`,
// que enxerga mensagens que a tela ainda não carregou) e a última mensagem
// RECEBIDA que a tela já tem — é ela que reabre a janela na hora em que chega.

export const JANELA_MS = 24 * 60 * 60 * 1000;
// A partir daqui o aviso âmbar aparece: dá tempo de responder o que importa.
export const AVISO_MS = 4 * 60 * 60 * 1000;
// Folga contra relógio adiantado e o tempo entre a Meta receber e o advup gravar:
// melhor travar um minuto antes do que deixar sair uma mensagem que não chega.
export const FOLGA_MS = 60 * 1000;

const RECEBIDA = 0;

export const ultimaRecebida = (mensagens = []) =>
  mensagens.reduce(
    (maior, m) =>
      m?.message_type === RECEBIDA && !m.private && m.created_at > maior
        ? m.created_at
        : maior,
    0
  );

export function calcularJanela({ fechaEmServidor, mensagens, agora }) {
  const pelaTela = ultimaRecebida(mensagens);
  const fechaEm =
    Math.max(
      (Number(fechaEmServidor) || 0) * 1000,
      pelaTela ? pelaTela * 1000 + JANELA_MS : 0
    ) || null;

  if (!fechaEm) {
    return {
      estado: 'fechada',
      nuncaEscreveu: true,
      fechaEm: null,
      ultimaDoCliente: null,
      restante: 0,
      fracao: 0,
    };
  }

  const restante = Math.max(fechaEm - FOLGA_MS - agora, 0);
  let estado = 'aberta';
  if (restante === 0) estado = 'fechada';
  else if (restante <= AVISO_MS) estado = 'acabando';

  return {
    estado,
    nuncaEscreveu: false,
    fechaEm,
    ultimaDoCliente: fechaEm - JANELA_MS,
    restante,
    // quanto das 24 h ainda sobra (0..1) — a barra do aviso
    fracao: Math.min(restante / JANELA_MS, 1),
  };
}

// "2 h 14 min", "38 min", "menos de 1 min" — as partes vão para o i18n.
export function partesDoRestante(ms) {
  const minutos = Math.floor(ms / 60000);
  return { horas: Math.floor(minutos / 60), minutos: minutos % 60 };
}
